// @flow
/* eslint-disable import/no-dynamic-require */

import type {IconAsset} from 'sail/Icon/types';

const createAsset = (
  category: string,
  name: string,
  options?: $Shape<IconAsset> = {},
): IconAsset => ({
  ...options,
  category: (category: any),
  name,
  // $FlowExpectedError Webpack will take care of the dynamic import for us.
  svg: require(`./${category}/DocsIcon--${name}.svg`).default,
});

export const DocsIconAssets = {
  general: {
    country: createAsset('general', 'country'),
    locale: createAsset('general', 'locale'),
    thumbsdown: createAsset('general', 'thumbsdown'),
    thumbsup: createAsset('general', 'thumbsup'),
    github: createAsset('general', 'github'),
    list: createAsset('general', 'list'),
    video: createAsset('general', 'video'),
    guide: createAsset('general', 'guide'),
    bluecheckmark: createAsset('general', 'bluecheckmark'),
  },
  nav: {
    account: createAsset('nav', 'account'),
    business: createAsset('nav', 'business'),
    developertools: createAsset('nav', 'developertools'),
    financialservices: createAsset('nav', 'financialservices'),
    home: createAsset('nav', 'home'),
    mobilenav: createAsset('nav', 'mobilenav'),
    payments: createAsset('nav', 'payments'),
    reference: createAsset('nav', 'reference'),
    security: createAsset('nav', 'security'),
  },
  product: {
    account: createAsset('product', 'account', {colorable: false}),
    atlas: createAsset('product', 'atlas', {colorable: false}),
    capital: createAsset('product', 'capital', {colorable: false}),
    checkout: createAsset('product', 'checkout', {colorable: false}),
    climate: createAsset('product', 'climate', {colorable: false}),
    connect: createAsset('product', 'connect', {colorable: false}),
    corporatecard: createAsset('product', 'corporatecard', {colorable: false}),
    dashboard: createAsset('product', 'dashboard', {colorable: false}),
    developertools: createAsset('product', 'developertools', {
      colorable: false,
    }),
    elements: createAsset('product', 'elements', {colorable: false}),
    gateddocs: createAsset('product', 'gateddocs'),
    identity: createAsset('product', 'identity', {colorable: false}),
    invoicing: createAsset('product', 'invoicing', {colorable: false}),
    issuing: createAsset('product', 'issuing', {colorable: false}),
    partners: createAsset('product', 'partners', {colorable: false}),
    payments: createAsset('product', 'payments', {colorable: false}),
    radar: createAsset('product', 'radar', {colorable: false}),
    reporting: createAsset('product', 'reporting', {colorable: false}),
    sigma: createAsset('product', 'sigma', {colorable: false}),
    styleguide: createAsset('product', 'styleguide'),
    implementationguides: createAsset('product', 'implementationguides'),
    tax: createAsset('product', 'tax', {colorable: false}),
    terminal: createAsset('product', 'terminal', {colorable: false}),
    treasury: createAsset('product', 'treasury', {colorable: false}),
  },
};
